"use strict";

import gsap from "gsap";
import { CustomEase, Flip } from "gsap/all";

const toProjEnterAnimation = function (container) {
	gsap.registerPlugin(Flip);
	gsap.registerPlugin(CustomEase);

	const body = container.parentElement;
	const info = container.querySelectorAll(".proj-info ul");
	const title = container.querySelector(".title");
	const imgCon = container.querySelector(".main-image");
	const content = container.querySelector(".content");

	const h = imgCon.offsetHeight;
	const t = imgCon.offsetTop;
	const vh = window.innerHeight;
	const fp = vh * 0.15;
	const tp = (Math.abs(t - fp) / h) * 100;

	const tl = gsap.timeline();

	tl.from(imgCon, {
		y: `-${tp}%`,
		rotate: -4,
		duration: 1.5,
		ease: CustomEase.create(
			"custom",
			"M0,0 C0.12,0.024 0.176,0.338 0.2,0.5 0.276,1.027 0.516,0.987 1,1 "
		),
	})
		.from(title, { yPercent: -150, duration: 1.5, ease: "power2.out" }, 0)
		.from(title, { opacity: 0, duration: 0.4, ease: "none" }, "<0.3")
		.from(
			info,
			{
				yPercent: -150,
				duration: 1.5,
				ease: "power2.out",
				stagger: 0.15,
			},
			"<"
		)
		.from(info, { opacity: 0, duration: 0.5, ease: "none", stagger: 0.15 }, "<0.2")
		.from(content, { autoAlpha: 0, duration: 1, ease: "none" }, "-=1.6");

	return tl;
};

export default toProjEnterAnimation;
